import { motion } from "framer-motion";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { usePartnerForm } from "@/components/onboarding/PartnerFormContext";

const BarcelonaSection = () => {
  const { t } = useTranslation();
  const { open: openPartner } = usePartnerForm();
  const dots = useMemo(
    () =>
      Array.from({ length: 60 }).map(() => ({
        top: Math.random() * 100,
        left: Math.random() * 100,
        delay: Math.random() * 4,
        duration: 2.5 + Math.random() * 3,
      })),
    []
  );

  return (
    <section id="barcelona" data-header-theme="blue" className="relative overflow-hidden bg-black pb-24 pt-10 text-white md:pb-32 md:pt-14">
      {/* pixel starfield */}
      <div aria-hidden className="pointer-events-none absolute inset-0">
        {dots.map((d, i) => (
          <motion.span
            key={i}
            className="absolute block h-[3px] w-[3px] bg-white"
            style={{ top: `${d.top}%`, left: `${d.left}%`, boxShadow: "0 0 6px rgba(255,255,255,0.9)" }}
            animate={{ opacity: [0.45, 1, 0.45] }}
            transition={{ duration: d.duration, delay: d.delay, repeat: Infinity, ease: "linear" }}
          />
        ))}
      </div>

      <div className="container relative mx-auto flex flex-col items-center px-4 text-center md:px-6">



        {/* Headline */}
        <h2
          className="mt-10 max-w-3xl font-serif text-[1.75rem] font-normal leading-[1.08] tracking-[-0.01em] text-white/45 md:text-4xl lg:text-5xl"
        >
          {t("sHome.barcelonaSection.headline")}{" "}
          <span className="text-white">{t("sHome.barcelonaSection.headlineHighlight")}</span>.
        </h2>

        {/* Subtext */}
        <p
          className="mt-8 max-w-3xl text-lg leading-relaxed text-white/45 sm:text-xl md:text-2xl"
        >
          {t("sHome.barcelonaSection.subtext")}
        </p>

        {/* Vertical line */}
        <div
          className="mt-14 h-20 w-px origin-top bg-white/25"
        />

        {/* CTA */}
        <div
          className="mt-14 flex flex-col items-center"
        >
          <span className="font-dot text-xs tracking-[0.15em] text-brand-blue md:text-sm">
            {t("sHome.barcelonaSection.ctaLabel")}
          </span>
          <button
            type="button"
            onClick={openPartner}
            className="group mt-5 inline-flex items-center gap-3 w-full justify-center bg-brand-blue px-6 py-4 text-base sm:w-auto sm:justify-start sm:px-14 text-black transition-opacity hover:opacity-90 md:text-lg"
          >
            {t("sHome.barcelonaSection.ctaButton")}
            <span className="inline-block transition-transform duration-300 group-hover:translate-x-1">
              →
            </span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default BarcelonaSection;
